/**
 * @generated SignedSource<<2c84f9526b2ddcef65425e4dad023ef5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Feed_enquiry$data = {
  readonly __typename: "Enquiry";
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"FeedEmailForm_enquiry" | "FeedNewForm_enquiry">;
  readonly " $fragmentType": "Feed_enquiry";
};
export type Feed_enquiry$key = {
  readonly " $data"?: Feed_enquiry$data;
  readonly " $fragmentSpreads": FragmentRefs<"Feed_enquiry">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Feed_enquiry",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FeedNewForm_enquiry"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FeedEmailForm_enquiry"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Enquiry",
  "abstractKey": null
};

(node as any).hash = "cec1257314f772581d39ccf66f1364fd";

export default node;
